// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import 'font-awesome/css/font-awesome.min.css'
import 'babel-polyfill'
import promise from 'es6-promise'
import vSelect from 'vue-select'
import $api from '@/api/api.js'
import $apiDQS from '@/api/apiDQS.js'
import layer from 'layui-layer'
import {getCookie, GetQueryString, signOut} from '@/assets/js/common/common.js'
import {ErrorModel, layerLoad, layerClose} from '@/assets/js/common/layerModel.js'
import {Pagination, Table, TableColumn, Upload} from 'element-ui'
import stockHeader from '@/components/header/stockHeader.vue'
import routerNav from '@/components/routerNavigation.vue'
import pageFooter from '@/components/pageFooter'
import Tip from "@/components/Tip"
// import Modal from "@/components/Modal"
import utils from '@/utils'

import fileDownload from 'js-file-download'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.config.productionTip = false
Vue.use(VueI18n)
/* eslint-disable no-new */
Vue.component('v-select', vSelect)
Vue.component('v-Pagination', Pagination)
Vue.component('v-Table', Table)
Vue.component('v-TableColumn', TableColumn)
Vue.component('v-Upload', Upload)
Vue.component('stockHeader', stockHeader)
Vue.component('routerNav', routerNav)
Vue.component('pageFooter',pageFooter)
Vue.component('Tip',Tip)
// Vue.component('Modal',Modal)

const i18n = new VueI18n({
  locale: getCookie('userLanguage') ? getCookie('userLanguage') : 'zh',
  messages: {
    'zh': require('./assets/i18n/zh'),
    'en': require('./assets/i18n/en')
  }
})

promise.polyfill()

let echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/tree')
require('echarts/lib/chart/graph')
Vue.prototype.$echarts = echarts
// 挂载全局函数
Vue.prototype.getCookie = getCookie
Vue.prototype.GetQueryString = GetQueryString
Vue.prototype.signOut = signOut
Vue.prototype.ErrorModel = ErrorModel
Vue.prototype.layerLoad = layerLoad
Vue.prototype.layerClose = layerClose
Vue.prototype.$api = $api
Vue.prototype.$apiDQS = $apiDQS
Vue.prototype.$layer = layer
Vue.prototype.utils = utils
Vue.prototype.fileDownload = fileDownload

new Vue({
  el: '#app',
  router,
  i18n,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js